import { useDispatch } from "react-redux";
import { loadUserProfile } from "./authActions";

export const setActiveProjet = (projet) => ({
    type: "SET_ACTIVE_PROJET",
    payload: projet,
});
export const setProjetsClients = (projets) => ({
    type: "SET_PROJETS_CLIENTS",
    payload: projets,
});
export const fetchProjetsClients =(token) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  return async (dispatch) => {
    try {
      const response = await fetch(`${apiUrl}/api/projects`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || "Erreur lors du chargement des projets");
      }

      dispatch(setProjetsClients(data.projets || []));
      return data.projets;
    } catch (error) {
      console.error("Erreur fetchProjets:", error);
      throw error;
    }
  };
};
export const refuseProjet = (token, idProjet) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  return async () => {
    try {
      const formData = new FormData();
      formData.append("idProjet", idProjet);

      const response = await fetch(`${apiUrl}/api/projects/refuse`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formData
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || "Erreur lors du refus du projet");
      }

      return data; // on renvoie juste la réponse
    } catch (error) {
      console.error("Erreur :", error);
      throw error;
    }
  }
}

export const cancelProjet = (token, idProjet) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  return async (dispatch) => {
    try {
      const formData = new FormData();
      formData.append("idProjet", idProjet);

      const response = await fetch(`${apiUrl}/api/projects/cancel`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formData
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || "Erreur lors de l'annulation du projet");
      }
      dispatch(setActiveProjet(null));
      dispatch(fetchProjetsClients(token));
      return data; // on renvoie juste la réponse
    } catch (error) {
      console.error("Erreur :", error);
      throw error;
    }
  }
}

export const selectPresta = (token,matchId) => {
    const apiUrl = process.env.REACT_APP_API_URL;
  return async (dispatch) => {
    try {
      const formData = new FormData();

      formData.append("idMatch", matchId);

      const response = await fetch(`${apiUrl}/api/projects/selectPresta`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formData,
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || "Erreur lors de la selection du match");
      }

      dispatch(fetchProjetsClients(token));

    } catch (error) {
      console.error("Erreur selectPresta:", error);
      throw error;
    }
  };
}
